import { useCallback, useRef } from 'react';
export default function useCallbackWithCtx(cb, ctx) {
    const ctxRef = useRef(ctx);
    ctxRef.current = ctx;
    return useCallback((...args) => cb(ctxRef.current, ...args), []);
}
